import { FC } from 'react'
import { DevTool } from 'src/features/development'
import { useDevelopmentHooks } from 'src/features/development/hooks'

const devToolStyle = {
  // 画像表示させたい時は canvasResetter をコメントアウトすること
  // backgroundImage: `url(${'/spike_rear4.JPG'})`,
  // backgroundRepeat: 'no-repeat',
  // backgroundPosition: 'left -80px top 100px',
  // backgroundSize: '80%'
  // maxWidth: '100%',
  // zIndex: 1000
  // transform: `rotate(-3deg)`
}

type Props = {
  rearSurfaceId: string
  maxWidth?: '100%' | '50%' | '30%'
}

export const RearSurface: FC<Props> = ({ rearSurfaceId, maxWidth = '100%' }) => {
  const { devFlg, devTools, handleCoordinate } = useDevelopmentHooks()
  return (
    <>
      {devFlg === 'true' ? (
        <div>
          <canvas width={880} height={680} id={rearSurfaceId} style={{ ...devToolStyle }} onClick={(e) => handleCoordinate(e)} />
          <DevTool devTools={devTools} />
        </div>
      ) : (
        <canvas id={rearSurfaceId} width={880} height={680} style={{ maxWidth }} />
      )}
    </>
  )
}
